import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FetchDestinations } from '../../../../actions/destinations';
import dayjs from 'dayjs';


class NextDestinationPanel extends PureComponent {

  constructor(props){
    super(props);
    this.onNextDestination = this.onNextDestination.bind(this);
  }

  onNextDestination(){
    const {
      FetchDestinations,
      itineraries:{sectors, iso_currency, tms_group_booking_id}
    } = this.props;


    // Check if sector or tour and use last departure date or end of tour date (include the duration)
    // Note - add 1 additional day to prevent same day departures
    const lastItem = sectors[sectors.length -1];
    const lastReservation = lastItem.transfer.end_city;
    let lastDepartureDate = dayjs(new Date(lastItem.transfer.date_for)).add(lastItem.duration, 'days').format("YYYY-MM-DD");

    FetchDestinations(iso_currency, lastReservation, lastDepartureDate, tms_group_booking_id);
  }

  render(){
    return (
      <div className="next-destination-panel cyoa" onClick={this.onNextDestination}>
        <div className="row">
          <div className="column small-12">
            <p className="no-margin">
              <svg width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fillRule="evenodd">
                  <circle fill="#F60" cx="7.5" cy="7.5" r="7.5"/>
                  <path d="M11.8 7.1h-4V3.2s0-.2-.2-.2h-.2c-.2 0-.3.1-.3.2v4H3.2s-.2 0-.2.2v.2c0 .2.1.3.2.3h4v3.9s0 .2.2.2h.2c.2 0 .3-.1.3-.2v-4h3.9s.2 0 .2-.2v-.2c0-.2-.1-.3-.2-.3z" fill="#FFF" fillRule="nonzero"/>
                </g>
              </svg>
              Add next destination
            </p>
          </div>
        </div>
      </div>
    )
  }

}

function mapStateToProps(state){
  return {
    itineraries:state.itineraries.data
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    FetchDestinations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(NextDestinationPanel);



// WEBPACK FOOTER //
// ./src/components/itinerary/editTrip/components/next-destination-panel.js